module.exports = __webpack_public_path__ + "img/logo-white.423f600f.png";